import React from "react"

import Layout from "components/Blog/Layout"
import Landing from "./Landing"
import ContentGroup from "./ContentGroup";

const StoryPage = (props) => {
	const {
		title, img, text, heroes, prisms, factions
	} = props

	return (
		<Layout ignoreTopPadding>
			<Landing title={title} text={text} img={img} />
			<ContentGroup type="hero" {...heroes} />
			<ContentGroup type="prism" {...prisms} />
			<ContentGroup type="faction" {...factions} />
		</Layout>
	)
}

export default StoryPage